import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  return (
    <Row
      style={{
        justifyContent: "center",
        paddingBottom: "10px",
        color: "white",
      }}
    >
      <h1 className="project-heading pb-4" style={{ paddingBottom: "20px" }}>
        Days I <strong className="purple">Code</strong>
      </h1>
      <GitHubCalendar
        username="Sumitkmt946"
        blockSize={30}
        blockMargin={10}
        color="#c084f5"
        fontSize={20}
        style={{ color: "transparent" }}  // This might not work directly on the component depending on implementation
        renderBlock={(block, activity) => (
          <div title={`${activity.count} activities on ${activity.date}`}>
            {block}
          </div>
        )}
      />
    </Row>
  );
}

export default Github;
